"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplienceImageStudio = void 0;
const errors_1 = require("./errors");
const types_1 = require("./types");
const LegacyHelpers_1 = require("./utils/LegacyHelpers");
class AmplienceImageStudio {
    constructor(options) {
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(this, "eventListeners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "defaultMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
    }
    withEventListener(eventType, callback) {
        if (types_1.eventListenerCallbackConfig[eventType]) {
            this.eventListeners[eventType] = callback;
        }
        else {
            console.warn(`Unable to register event listener with ImageStudioEventType: ${eventType}, no configuration available`);
        }
        return this;
    }
    withDecodedOrgId(orgId) {
        this.defaultMetadata.orgId = btoa(`Organization:${orgId}`);
        return this;
    }
    withEncodedOrgId(orgId) {
        this.defaultMetadata.orgId = orgId;
        return this;
    }
    editImages(inputImages) {
        const instance = this.createInstance();
        return instance.launch(this.defaultMetadata, {
            allowImageSave: true,
            allowLogout: false,
            allowCreate: false,
        }, inputImages);
    }
    launch() {
        const instance = this.createInstance();
        return instance.launch(this.defaultMetadata, {
            allowImageSave: false,
            allowLogout: true,
            allowCreate: true,
        }, [], 'create');
    }
    createInstance() {
        return new AmplienceImageStudioInstance(this.options, this.eventListeners);
    }
}
exports.AmplienceImageStudio = AmplienceImageStudio;
class AmplienceImageStudioInstance {
    constructor(options, eventListeners) {
        Object.defineProperty(this, "_resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "launchProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "instanceWindow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pollingInterval", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "usingLegacyEventFormat", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "eventListenerCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.handleEvent = this.handleEvent.bind(this);
        this.handleLegacyImageSave = this.handleLegacyImageSave.bind(this);
        this.options = options;
        this.eventListenerCallback = Object.assign(Object.assign({}, this.getInternalEventListeners()), eventListeners);
    }
    getInternalEventListeners() {
        return {
            IMAGE_SAVE: this.handleLegacyImageSave,
        };
    }
    launch(defaultSdkMetadata, actionSdkMetadata, inputImages, route = '') {
        var _a;
        const promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
        const { domain, windowTarget = '_blank', windowFeatures } = this.options;
        const imageStudioUrl = route && route.trim().length > 0
            ? `${domain}/image-studio/${route.trim()}`
            : `${domain}/image-studio`;
        const newWindow = window.open(imageStudioUrl, windowTarget, windowFeatures);
        if (!newWindow) {
            this.reject(new errors_1.ApplicationBlockedError());
        }
        else {
            const sdkMetadata = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.sdkMetadataOverride)
                ? Object.assign(Object.assign(Object.assign({}, defaultSdkMetadata), actionSdkMetadata), this.options.sdkMetadataOverride) : Object.assign(Object.assign({}, defaultSdkMetadata), actionSdkMetadata);
            this.launchProps = {
                imageStudioUrl,
                sdkMetadata,
                inputImages,
            };
            this.instanceWindow = newWindow;
            window.addEventListener('message', this.handleEvent);
            newWindow.focus();
            this.pollingInterval = window.setInterval(() => {
                if (newWindow.closed) {
                    this.deactivate();
                    this.resolve({
                        reason: types_1.ImageStudioReason.CLOSED,
                    });
                }
            }, 100);
        }
        return promise;
    }
    handleEvent(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (!(event.data instanceof Object)) {
                return;
            }
            let eventData;
            if ('type' in event.data) {
                eventData = event.data;
            }
            else {
                eventData = (0, LegacyHelpers_1.translateLegacyImageStudioEvent)((using) => {
                    this.usingLegacyEventFormat = using;
                }, event.data);
            }
            if (eventData === null || eventData === void 0 ? void 0 : eventData.type) {
                switch (eventData.type) {
                    case types_1.ImageStudioEventType.Connect:
                        if (!this.isActive) {
                            this.handleActivate();
                        }
                        break;
                    case types_1.ImageStudioEventType.Disconnect:
                        if (this.isActive) {
                            this.isActive = false;
                        }
                        break;
                    default:
                        break;
                }
                const config = types_1.eventListenerCallbackConfig[eventData.type];
                if (config) {
                    let sendDefaultResponse = true;
                    if (eventData.type in this.eventListenerCallback) {
                        try {
                            const responseType = yield ((_b = (_a = this.eventListenerCallback)[eventData.type]) === null || _b === void 0 ? void 0 : _b.call(_a, eventData.data));
                            if (responseType && config.validResponses.includes(responseType)) {
                                sendDefaultResponse = false;
                                this.sendSDKEvent({
                                    type: responseType,
                                    trigger: eventData.type,
                                    data: {},
                                });
                            }
                            else if (responseType) {
                                console.log(`Invalid response type ${responseType} for eventListener with type: ${eventData.type}`);
                            }
                        }
                        catch (error) {
                            console.log(`Users Event Listener has thrown an error: '${error.message}'`);
                        }
                    }
                    if (sendDefaultResponse) {
                        const defaultEventType = config.defaultResponse;
                        if (defaultEventType != null) {
                            this.sendSDKEvent({
                                type: defaultEventType,
                                trigger: eventData.type,
                                data: {},
                            });
                        }
                    }
                }
            }
        });
    }
    handleActivate() {
        var _a;
        this.isActive = true;
        this.sendSDKEvent({
            type: types_1.SDKEventType.Focus,
            data: {},
        });
        this.sendSDKEvent({
            type: types_1.SDKEventType.SDKMetadata,
            data: this.launchProps.sdkMetadata,
        });
        if (((_a = this.launchProps.inputImages) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.sendSDKEvent({
                type: types_1.SDKEventType.ImageInput,
                data: { images: this.launchProps.inputImages },
            });
        }
    }
    handleLegacyImageSave(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.resolve({
                reason: types_1.ImageStudioReason.IMAGE,
                image: data.image,
            });
            this.deactivate();
            return types_1.SDKEventType.Success;
        });
    }
    sendSDKEvent(event) {
        var _a;
        if (this.usingLegacyEventFormat) {
            (0, LegacyHelpers_1.sendLegacySDKEvent)(this.instanceWindow, event);
        }
        else {
            (_a = this.instanceWindow) === null || _a === void 0 ? void 0 : _a.postMessage(event, '*');
        }
    }
    deactivate() {
        window.removeEventListener('message', this.handleEvent);
        if (this.instanceWindow) {
            this.instanceWindow.close();
        }
        clearInterval(this.pollingInterval);
    }
    resolve(value) {
        this._resolve && this._resolve(value);
        this._resolve = undefined;
        this._reject = undefined;
    }
    reject(reason) {
        this._reject && this._reject(reason);
        this._resolve = undefined;
        this._reject = undefined;
    }
}
//# sourceMappingURL=AmplienceImageStudio.js.map